var map = {
	"./bakulla.png": "./src/Containers/Play/HitTheWall/content/images/level2/bakulla.png",
	"./bhedigoth.png": "./src/Containers/Play/HitTheWall/content/images/level2/bhedigoth.png",
	"./chayau.png": "./src/Containers/Play/HitTheWall/content/images/level2/chayau.png",
	"./chulaci.png": "./src/Containers/Play/HitTheWall/content/images/level2/chulaci.png",
	"./dumsi.png": "./src/Containers/Play/HitTheWall/content/images/level2/dumsi.png",
	"./ghuchha.png": "./src/Containers/Play/HitTheWall/content/images/level2/ghuchha.png",
	"./ghumba.png": "./src/Containers/Play/HitTheWall/content/images/level2/ghumba.png",
	"./gunji.png": "./src/Containers/Play/HitTheWall/content/images/level2/gunji.png",
	"./karauti.png": "./src/Containers/Play/HitTheWall/content/images/level2/karauti.png",
	"./lapsi.png": "./src/Containers/Play/HitTheWall/content/images/level2/lapsi.png",
	"./mobile.png": "./src/Containers/Play/HitTheWall/content/images/level2/mobile.png",
	"./naksha.png": "./src/Containers/Play/HitTheWall/content/images/level2/naksha.png",
	"./nibuwa.png": "./src/Containers/Play/HitTheWall/content/images/level2/nibuwa.png",
	"./pachis.png": "./src/Containers/Play/HitTheWall/content/images/level2/pachis.png",
	"./pidhi.png": "./src/Containers/Play/HitTheWall/content/images/level2/pidhi.png",
	"./posak.png": "./src/Containers/Play/HitTheWall/content/images/level2/posak.png",
	"./sakkar.png": "./src/Containers/Play/HitTheWall/content/images/level2/sakkar.png",
	"./sayal.png": "./src/Containers/Play/HitTheWall/content/images/level2/sayal.png",
	"./surya.png": "./src/Containers/Play/HitTheWall/content/images/level2/surya.png",
	"./whale.png": "./src/Containers/Play/HitTheWall/content/images/level2/whale.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Containers/Play/HitTheWall/content/images/level2 sync recursive ^\\.\\/.*$";